import React from "react";
import './Medicine.css';

class Medicine extends React.Component {
    render() {
        return (
            <article className="article br3 ba b--black-10 w-100 w-50-m w-50-l mw7 shadow-5 center">
                <main className="pa4 black-80">
                    <div className="measure">
                        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                            <div className='legend center'>
                                <legend className="f1 fw6 ph0 mh0">دراسة المجال الطبي و استكماله في المانيا</legend>
                            </div>
                            <hr/>

                            <div className="ui form ma0">
                                <div className="fields">
                                    <h3>
                                        فيه بوستات كتيرة نزلت عن المجال الطبي ككتب او تجارب او بوستات عن الدراسة والشغل و ناس كتير بتسأل عنها و مشفتهاش
                                        <br/>
                                        فـ في البوست دة هحاول اجمعهم لان البوستات دى مهمة جدا و مفيدة
                                        <br/>
                                        ______________________________________
                                        <br/>
                                        أولا الدراسة
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/459795481065844/'>جامعات الطب البشرى في المانيا</a>
                                        <br/>
                                        ...................
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/459768991068493/'>جامعات العلاج الطبيعى في المانيا</a>
                                        <br/>
                                        ...................
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/449893155389410/'>تجارب الحصول على قبول بكالوريوس للطب البشرى</a> -- <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/545204162524975/'>كمان تجربه</a>
                                        <br/>
                                        ...................
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/455855228126536/'>معادلة المواد للمجال الطبى لاستكمال دراسة البكالوريوس</a>
                                        <br/>
                                        ...................
                                        <br/>
                                        ثانيا الشغل و المعادلة
                                        سلسلة بوستات د/هشام جابر عن المعادلة والشغل
                                        <br/>
                                        <div className='lft'>
                                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/445599145818811/'>facebook.com/../permalink/445599145818811</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/449760825402643/'>facebook.com/../permalink/449760825402643</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/456025034776222/'>facebook.com/../permalink/456025034776222</a> 
                                        </div>
                                        ...................
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/449826098729449/'>بوست لـ عمر أيمن عن فيزا المعادلة</a> 
                                        <br/>
                                        ...................
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/396815640697162/'>الأختبار البورد الالماني(الفاخ ارتس). ما هو ؟</a> 
                                        <br/>
                                        ...................
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/462700007442058/'>طريقة المعادلة لدكاترة الطب بيطرى</a> 
                                        <br/>
                                        ...................
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/637180446435431/'>جروب لدكاترة الطب البشرى للتحضير للمعادلة في المانيا</a> 
                                        <br/>
                                        ...................
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/1780206302236912'>جروب لدكاترة طب الاسنان للتحضير للمعادلة في المانيا</a> 
                                        <br/>
                                        ................... 
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/327302350739728/?ref=br_rs'>جروب لدكاترة الصيدلة للتحضير للمعادلة في المانيا</a> 
                                        <br/>
                                        ...................
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/377408505663230/'>جروب للدكاترة المصريين فى المانيا</a> 
                                        <br/>
                                        ...................
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/463946750650717/'>تجربة طبيب في الحصول علي المعادلة الالمانية في المانيا والعمل هناك</a> 
                                        <br/>
                                        ______________________________________
                                        <br/>
                                        ثالثا الكتب و الفيديوهات
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/.../permalink/462889367423122/'>كتاب الخاص بتدريب التمريض لطلبة التمريض او المتخرجين</a>
                                        <br/>
                                        ...................
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/.../permalink/460328807679178/'>الكتب الطبية اللي هتحتاجها كطبيب للعمل في المانيا</a>
                                        <br/>
                                        ...................
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/414213135624079/'>مصطلحات طبية بالألمانى</a> 
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/413836145661778/'>مصطلحات كمان</a>
                                        <br/>
                                        ...................
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/460328301012562/'>كتاب طب التخدير</a>
                                        <br/>
                                        ...................
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/.../permalink/458066487905410/'>مسلسل الماني طبي في المستشفي وحياة الدكاترة والممرضات</a>
                                        <br/>
                                        ...................
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/412865839092142/'>افضل قناه علي اليوتيوب للتحضير لامتحان الفاخشبراخة الطبي للدكاترة البشري</a>
                                        <br/>
                                        ...................
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/394694867575906/'>موقع بيشرحلك اناتومي وهستولوجي بالالماني للطلبة وللدكاترة اللي هتشتغل في المانيا</a>
                                        <br/>
                                        ...................
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/.../permalink/460003877711671/'>تجميعة لمواقع مفيدة للاطباء</a>
                                    </h3>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </main>
            </article>
        );
    }
}

export default Medicine;
